import Main from './main';
import Solution from './solution';
import PrivacyTerm from './privacy-term';

export default function Footer() {
	return (
		<>
			<Solution/>
			<Main/>
			<PrivacyTerm/>
		</>
	);
}